export default __webpack_public_path__ + "static/image03-c3c31592da96a7f1e63df5e836ce88a6.webp";